import { render, staticRenderFns } from "./FormDirectory.vue?vue&type=template&id=04f13fdd&scoped=true"
import script from "./FormDirectory.vue?vue&type=script&lang=js"
export * from "./FormDirectory.vue?vue&type=script&lang=js"
import style0 from "./FormDirectory.vue?vue&type=style&index=0&id=04f13fdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f13fdd",
  null
  
)

export default component.exports